import { Color, Vector2, WebGLRenderer } from 'three';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { IfcComponent } from '../../../base-types';
import { IfcPostproduction } from './postproduction';
export class IfcRenderer extends IfcComponent {
    constructor(context) {
        super(context);
        this.basicRenderer = new WebGLRenderer({ antialias: true });
        this.renderer2D = new CSS2DRenderer();
        this.renderer = this.basicRenderer;
        this.postProductionActive = false;
        this.blocked = false;
        this.context = context;
        this.container = context.options.container;
        this.setupRenderers();
        this.postProductionRenderer = new IfcPostproduction(this.context, this.basicRenderer.domElement);
        this.adjustRendererSize();
    }
    get usePostproduction() {
        return this.postProductionActive;
    }
    set usePostproduction(active) {
        if (this.postProductionActive === active)
            return;
        this.postProductionActive = active;
        this.renderer = active ? this.postProductionRenderer : this.basicRenderer;
        if (!active)
            this.restoreRendererBackgroundColor();
    }
    dispose() {
        this.basicRenderer.domElement.remove();
        this.basicRenderer.dispose();
        this.postProductionRenderer.dispose();
        this.basicRenderer = null;
        this.renderer2D = null;
        this.postProductionRenderer = null;
        this.renderer = null;
        this.container = null;
        this.context = null;
    }
    update(_delta) {
        if (this.blocked)
            return;
        const scene = this.context.getScene();
        const camera = this.context.getCamera();
        this.renderer.render(scene, camera);
        this.renderer2D.render(scene, camera);
    }
    getSize() {
        return new Vector2(this.basicRenderer.domElement.clientWidth, this.basicRenderer.domElement.clientHeight);
    }
    adjustRendererSize() {
        this.basicRenderer.setSize(this.container.clientWidth, this.container.clientHeight);
        this.renderer2D.setSize(this.container.clientWidth, this.container.clientHeight);
        this.postProductionRenderer.setSize(this.container.clientWidth, this.container.clientHeight);
    }
    newScreenshot(camera, dimensions) {
        const previousDimensions = this.getSize();
        const domElement = this.basicRenderer.domElement;
        const tempCanvas = domElement.cloneNode(true);
        // Using a new renderer to make screenshots without updating what the user sees in the canvas
        const tempRenderer = new WebGLRenderer({ canvas: tempCanvas, antialias: true });
        tempRenderer.localClippingEnabled = true;
        if (dimensions) {
            tempRenderer.setSize(dimensions.x, dimensions.y);
            this.context.ifcCamera.updateAspect(dimensions);
        }
        const scene = this.context.getScene();
        const cameraToRender = camera || this.context.getCamera();
        tempRenderer.render(scene, cameraToRender);
        const result = tempRenderer.domElement.toDataURL();
        if (dimensions)
            this.context.ifcCamera.updateAspect(previousDimensions);
        tempRenderer.dispose();
        tempCanvas.remove();
        return result;
    }
    setupRenderers() {
        this.basicRenderer.localClippingEnabled = true;
        this.container.appendChild(this.basicRenderer.domElement);
        this.renderer2D.domElement.style.position = 'absolute';
        this.renderer2D.domElement.style.top = '0px';
        this.renderer2D.domElement.style.pointerEvents = 'none';
        this.container.appendChild(this.renderer2D.domElement);
    }
    restoreRendererBackgroundColor() {
        this.basicRenderer.setClearColor(new Color(0, 0, 0), 0);
    }
}
//# sourceMappingURL=renderer.js.map